import script from "./RadarFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./RadarFeed.vue?vue&type=script&setup=true&lang=js"

import "./RadarFeed.vue?vue&type=style&index=0&id=3d738044&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d738044"]])

export default __exports__